import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { Background } from './Background';
import { FADE, MAX_LEADERS } from '../../HOME/const';
import * as f from '../logic';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { TT_BACKGROUND, CORNERS, SIDES } from '../const';
import { setUserId, showLeaderboards } from '../../HOME/REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';
import ModeIcon from '../COMPONENTS/ModeIcon';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    mode: this.props.mode,
    size: this.props.size,
    score: this.props.stats ? this.props.stats.grade : 0,
  };

  componentDidMount() {
    this.init(this.handleSelection);
  }

  getQuery = () => {
    const { mode, size } = this.state;

    return this.leaders
      .where('mode', '==', mode)
      .where('size', '==', size)
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey(mode, size) {
    mode = mode || this.state.mode;
    size = size || this.state.size;

    return `${this.props.app} LEADERS • ${mode.slice(0, 1)}${size}`;
  }

  userKey(id, size, mode) {
    id = id || this.props.uid;
    size = size || this.state.size;
    mode = mode || this.state.mode;

    return `${mode.slice(0, 1)}${size} • ${id}`;
  }

  handleSelection = (mode, size) => {
    mode = mode || this.state.mode;
    size = size || this.state.size;

    this.setState({ mode, size }, () => {
      this.getCachedLeaders(true);

      f.getStats({ mode, size }, stats => {
        const { grade, plays } = f.getMoreStats(stats, size);
        this.setState({ score: grade, plays }, this.updateRanks);
      });
    });
  };

  dataToSubmit = () => {
    const { mode, size, score, plays } = this.state;
    return { mode, size, name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton />
      <HomeButton />
    </>
  );

  render() {
    const background = TT_BACKGROUND;
    const rankColor = 'rgb(125,167,236)';
    const submitColor = 'rgb(37,50,70)';
    const scoreAlias = 'Grade';

    return (
      <>
        <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
          {this.renderClickableScreen()}
          <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
            <div className="leaders-selector">
              {_.map([CORNERS, SIDES], mode => {
                const current = mode === this.state.mode;
                const cls = `leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                return (
                  <div key={mode} className={cls} style={{ margin: '0 0.5em' }} onClick={() => this.handleSelection(mode)}>
                    <ModeIcon mode={mode} width={36} height={36} />
                  </div>
                );
              })}
              {_.map([2, 3, 4, 5], size => {
                const current = size === this.state.size;
                const sizeName = f.sizeName(size);
                const cls = `leaders-circle tt-leaders-size-selector leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                return (
                  <div key={size} className={cls} style={{ margin: '0 0.5em' }} onClick={() => this.handleSelection(null, size)}>
                    {sizeName}
                  </div>
                );
              })}
            </div>
            <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
              {_.map(this.state.users, (u, i) => (
                <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} scoreAlias={scoreAlias} />
              ))}
            </div>
            {this.renderCommon(rankColor, submitColor, scoreAlias)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards }
)(Leaderboard);
